<template>
  <Head title="Avid Payment Setup" />
  
  <div class="container-fluid">
    <div class="row justify-content-center mx-4">
      <div class="col p-0">
        <payment :proposal="proposal" :entity="entity" :entity-type="entityType" :user="auth.user"></payment>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
  proposal: Object,
  entity: Object,
  entityType: String,
  auth: Object
});
</script>

